// src/pages/DisclaimerPage.js
import React from 'react';
import HeaderBar from '../components/HeaderBar';
import Footer from '../components/Footer';
import '../styles/LandingPage.css';
import '../styles/AboutPage.css';

export default function DisclaimerPage() {
  return (
    <div className="landing-page landing-page--simple">
      <HeaderBar />

      <main className="search-hero" role="main">
        <div className="card" style={{ maxWidth: 820, width: '100%', textAlign: 'left' }}>
          <h2 style={{ marginTop: 0 }}>Legal &amp; Disclaimer</h2>
          <ul className="bullets">
            <li><strong>Beta software:</strong> getSurvey is in active beta. Features may change and data may be reset. Analytics and insights are experimental and may be inaccurate or incomplete.</li>
            <li><strong>No warranties:</strong> The service is provided “as is” and “as available” without warranties of any kind, express or implied.</li>
            <li><strong>User responsibility:</strong> Do not include or upload sensitive, confidential, or personal data in survey prompts or responses. You are solely responsible for the content you submit and for any consequences of sharing it.</li>
            <li><strong>AI content:</strong> AI‑generated content may be incorrect, irrelevant, or inappropriate. We apply best‑effort moderation but cannot guarantee prevention or removal of all problematic content. getSurvey is not responsible or liable for such outputs.</li>
            <li><strong>No liability:</strong> To the fullest extent permitted by law, getSurvey will not be liable for any loss of data, damages, costs, or claims arising from your use of the site, surveys, analytics, insights, or AI outputs.</li>
            <li><strong>Community guidelines:</strong> You agree not to post content that is unlawful, abusive, harassing, or violates third‑party rights. We may remove or restrict content at our discretion.</li>
            <li><strong>Age suitability:</strong> The service is intended for general audiences. If you are under the age permitted by your local law to consent to online services, you must use the service only with parental/guardian permission.</li>
            <li><strong>Third‑party services:</strong> We may use third‑party providers (including AI services). Your use of features powered by third parties may be subject to their terms and policies.</li>
            <li><strong>Changes:</strong> We may update this disclaimer and our policies over time. Continued use constitutes acceptance of the then‑current terms.</li>
          </ul>
          <p className="legal-note">
            To report an issue or request content removal, contact{' '}
            <a href="mailto:supports@getsurvey.app">supports@getsurvey.app</a>.
          </p>

          <section style={{ marginTop: 32 }}>
            <h2>Responsible Use Policy</h2>
            <p>
              This Responsible Use Policy (“Policy”) governs the manner in which users (“You” or “Users”)
              access and utilize the anonymous survey and feedback platform (“Platform”). By accessing or
              using the Platform, You agree to comply with this Policy and all applicable laws and regulations.
            </p>
            <h3>1. Purpose</h3>
            <p>
              The Platform is designed to facilitate the collection of honest, anonymous feedback and opinions
              to promote transparency, constructive dialogue, and organizational or community improvement. It is
              not intended to serve as a forum for defamatory, harmful, or unlawful content.
            </p>
            <h3>2. User Responsibilities</h3>
            <p>Users are solely responsible for the content they submit, including but not limited to survey questions, comments, and feedback. By using the Platform, You agree that You will not:</p>
            <ul className="bullets">
              <li>Submit any content that is false, misleading, defamatory, abusive, harassing, threatening, or otherwise unlawful.</li>
              <li>Disclose or attempt to disclose any personally identifiable information about any individual without their explicit consent.</li>
              <li>Use the Platform to impersonate others, spread misinformation, or engage in coordinated manipulation of survey results.</li>
              <li>Interfere with the normal operation, security, or integrity of the Platform or any related systems.</li>
            </ul>
            <h3>3. Anonymity and Privacy</h3>
            <p>
              The Platform is committed to preserving user anonymity and privacy. While certain technical information
              (such as session or network metadata) may be processed for security and anti-abuse purposes, no personally
              identifiable data is collected or disclosed without lawful justification.
            </p>
            <h3>4. Monitoring and Enforcement</h3>
            <p>
              The Platform reserves the right, but not the obligation, to monitor content submissions to ensure compliance
              with this Policy. The Platform may remove, restrict, or refuse access to any content or account that violates
              this Policy, applicable law, or the rights of others.
            </p>
            <h3>5. Disclaimer of Liability</h3>
            <p>
              The Platform disclaims all liability for user-generated content. Opinions and statements expressed by Users are
              solely those of the individual authors and do not reflect the views or policies of the Platform or its operators.
              The Platform shall not be held responsible for any harm, loss, or damage resulting from reliance on, or exposure to,
              user-submitted content.
            </p>
            <h3>6. Policy Updates</h3>
            <p>
              This Policy may be revised or updated periodically. Continued use of the Platform following any such changes
              constitutes acceptance of the revised Policy.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
